import pic1 from "./assest/d-1.jpg";
import pic2 from "./assest/d-2.jpg";
import pic3 from "./assest/d-3.jpg";
import pic4 from "./assest/d-4.jpg";

import pic5 from "./assest/d-5.jpg";
import pic6 from "./assest/d-6.jpg";
import pic7 from "./assest/d-7.jpg";
import pic8 from "./assest/d-8.jpg";
import pic9 from "./assest/d-9.jpg";
import pic10 from "./assest/d-10.jpg";
export const image = [
  {
    id: 1,
    img1: pic1,
  },
  {
    id: 2,
    img1: pic2,
  },
  {
    id: 3,
    img1: pic3,
  },
  {
    id: 4,
    img1: pic4,
  },
  {
    id: 5,
    img1: pic5,
  },
  {
    id: 6,
    img1: pic6,
  },
  {
    id: 7,
    img1: pic7,
  },
  {
    id: 8,
    img1: pic8,
  },
  {
    id: 9,
    img1: pic9,
  },
  {
    id: 10,
    img1: pic10,
  },
];
